import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProcessingGuidesSubscriptionVariables = Types.Exact<{
  guideIds: Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input'];
}>;


export type ProcessingGuidesSubscription = { __typename?: 'subscription_root', guides: Array<{ __typename?: 'guides', id: any, updated_at: any, title?: string | null, status: string, description?: string | null, video_url?: string | null, created_by_user_id?: string | null, organization_id?: any | null, guide_steps: Array<{ __typename?: 'guide_steps', id: any, title: string, body?: string | null, image_url?: string | null, video_url?: string | null }>, product_guides: Array<{ __typename?: 'product_guides', id: any, product?: { __typename?: 'products', id: any, photo_link?: string | null, installed_products: Array<{ __typename?: 'installed_products', id: any, property_id: any, photo_link?: string | null }>, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null }> } | null }> }> };


export const ProcessingGuidesDocument = gql`
    subscription processingGuides($guideIds: [uuid!]!) {
  guides(where: {id: {_in: $guideIds}}) {
    id
    updated_at
    title
    status
    description
    video_url
    guide_steps {
      id
      title
      body
      image_url
      video_url
    }
    product_guides {
      id
      product {
        id
        photo_link
        installed_products(distinct_on: property_id) {
          id
          property_id
          photo_link
        }
        product_attachments {
          id
          photo_link
        }
      }
    }
    created_by_user_id
    organization_id
  }
}
    `;

/**
 * __useProcessingGuidesSubscription__
 *
 * To run a query within a React component, call `useProcessingGuidesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProcessingGuidesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingGuidesSubscription({
 *   variables: {
 *      guideIds: // value for 'guideIds'
 *   },
 * });
 */
export function useProcessingGuidesSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProcessingGuidesSubscription, ProcessingGuidesSubscriptionVariables> & ({ variables: ProcessingGuidesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProcessingGuidesSubscription, ProcessingGuidesSubscriptionVariables>(ProcessingGuidesDocument, options);
      }
export type ProcessingGuidesSubscriptionHookResult = ReturnType<typeof useProcessingGuidesSubscription>;
export type ProcessingGuidesSubscriptionResult = Apollo.SubscriptionResult<ProcessingGuidesSubscription>;